/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_portalStaffNotificationLog_requestCountUnreadPortalStaffNotificationLog } from '../models/api_portalStaffNotificationLog_requestCountUnreadPortalStaffNotificationLog';
import type { api_portalStaffNotificationLog_requestListPortalStaffNotificationLog } from '../models/api_portalStaffNotificationLog_requestListPortalStaffNotificationLog';
import type { api_portalStaffNotificationLog_requestUpdateIsRead } from '../models/api_portalStaffNotificationLog_requestUpdateIsRead';
import type { api_portalStaffNotificationLog_responseCountUnreadPortalStaffNotificationLog } from '../models/api_portalStaffNotificationLog_responseCountUnreadPortalStaffNotificationLog';
import type { api_portalStaffNotificationLog_responseListPortalStaffNotificationLog } from '../models/api_portalStaffNotificationLog_responseListPortalStaffNotificationLog';
import type { api_portalStaffNotificationLog_responseUpdateIsRead } from '../models/api_portalStaffNotificationLog_responseUpdateIsRead';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PortalStaffNotificationLogService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Count Unread PortalStaffNotificationLog
     * 掲載スタッフ宛の未読通知履歴の件数を取得する。
     * @returns api_portalStaffNotificationLog_responseCountUnreadPortalStaffNotificationLog responseCountUnreadPortalStaffNotificationLog
     * @throws ApiError
     */
    public postPortalStaffNotificationLogCountUnread({
        body,
    }: {
        /**
         * requestCountUnreadPortalStaffNotificationLog
         */
        body: api_portalStaffNotificationLog_requestCountUnreadPortalStaffNotificationLog,
    }): CancelablePromise<api_portalStaffNotificationLog_responseCountUnreadPortalStaffNotificationLog> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_staff_notification_log/count_unread',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List PortalStaffNotificationLog
     * 掲載スタッフ宛の通知履歴の一覧を取得する。
     * @returns api_portalStaffNotificationLog_responseListPortalStaffNotificationLog responseListPortalStaffNotificationLog
     * @throws ApiError
     */
    public postPortalStaffNotificationLogList({
        body,
    }: {
        /**
         * requestListPortalStaffNotificationLog
         */
        body: api_portalStaffNotificationLog_requestListPortalStaffNotificationLog,
    }): CancelablePromise<api_portalStaffNotificationLog_responseListPortalStaffNotificationLog> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_staff_notification_log/list',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update PortalStaffNotificationLog IsRead
     * 掲載スタッフ宛の通知履歴を既読にする。
     * @returns api_portalStaffNotificationLog_responseUpdateIsRead responseUpdateIsRead
     * @throws ApiError
     */
    public postPortalStaffNotificationLogUpdateIsRead({
        body,
    }: {
        /**
         * requestUpdateIsRead
         */
        body: api_portalStaffNotificationLog_requestUpdateIsRead,
    }): CancelablePromise<api_portalStaffNotificationLog_responseUpdateIsRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_staff_notification_log/update_is_read',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
